import { useEffect } from '@wordpress/element';
import { addFilter, removeFilter } from '@wordpress/hooks';

/**
 * Allows adding a filter to the WordPress hooks system within a React component.
 *
 * Note: There is a limitation with this, components using the filter do not know
 * they should re-render when the filter is added or removed. This means that they
 * may be stale until their next re-render.
 *
 * @param {string}   hookName     The hook name to add the filter to
 * @param {string}   nameSpace    The namespace to use for the filter
 * @param {Function} callback     The callback function to execute when the filter is applied
 * @param {boolean}  shouldFilter Whether to add or remove the filter
 *
 * @return {void}
 */
const useFilter = (hookName, nameSpace, callback, shouldFilter = true) => {
  useEffect(() => {
    if (shouldFilter) {
      addFilter(hookName, nameSpace, callback);
    } else {
      removeFilter(hookName, nameSpace);
    }

    return () => {
      removeFilter(hookName, nameSpace);
    };
  }, [hookName, nameSpace, callback, shouldFilter]);
};

export default useFilter;
